// The signed-in user's numeric id, read from the JWT the API issued (its
// NameIdentifier claim - "nameid"/"sub", or the full claim URI).
//
// "Is this my own record?" must compare ids, never names: every record carries
// the id of whoever created / requested / submitted it (RequestedByUserId,
// CreatedBy, SubmittedBy, SalespersonUserId), which is unique, while the
// *ByName fields beside them are display text - first names only since
// 2026-09-14, which two people can share.
const NAME_ID_CLAIMS = ["nameid", "sub", "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];

export const userIdFromToken = (token) => {
  if (!token) return null;
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    // Only the numeric id is read, so the raw (byte-string) decode is enough.
    const json = JSON.parse(atob(payload.padEnd(payload.length + ((4 - (payload.length % 4)) % 4), "=")));
    for (const claim of NAME_ID_CLAIMS) {
      const id = Number(json[claim]);
      if (Number.isInteger(id) && id > 0) return id;
    }
  } catch {
    // A token we cannot read gives no id - callers treat that as "not mine".
  }
  return null;
};
